import * as React from "react";

;
export const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 13.083v-1.5c3.802 0 7.583-3.045 7.583-7.583h1.5c0 3.365-1.728 6.032-4.114 7.583H22v1.5H6.969c2.386 1.552 4.114 4.218 4.114 7.584h-1.5c0-4.529-3.765-7.57-7.559-7.584H2z" fill="#100722" /></svg>;